/* Copyright 2016-2017 The MathWorks, Inc. */

/**
 * This extends the GalleryItem and adds the behavior of being able to be checked. This is similar to how a ToggleButton
 * behaves.
 */

define([
    "dojo/_base/declare",
    "./GalleryItem",
    "../../constants/TypeConstants",
    "mw-form/mixins/event/ChangeEventMixin",
    "mw-form/mixins/property/CheckedMixin",
    "mw-form/mixins/property/ButtonGroupMixin",
    "MW/toolstrip/mixins/property/ButtonGroupMixin",
    "MW/toolstrip/mixins/property/RemovableMixin"
], function (declare, GalleryItem, TypeConstants, ChangeEventMixin, CheckedMixin, ButtonGroupMixin,
             TSButtonGroupMixin, RemovableMixin) {

    return declare([GalleryItem, ChangeEventMixin, CheckedMixin, ButtonGroupMixin, TSButtonGroupMixin, RemovableMixin], {

        baseClass: "mwWidget mwToggleGalleryItem",

        postCreate: function () {
            this.set("checkableNode", this.itemWrapperNode);
            this.inherited(arguments);
        },

        _setCheckedAttr: function (value, originator) {
            this.inherited(arguments);

            if (this._destroyed) {
                return;
            }

            var parent = this.getParent();
            var grandParent = null;

            // The gallery needs to be refreshed according to the following rules when scrollToSelection is true:
            // 1. If there is no other Gallery Item in the Gallery that is checked.
            // 2. If the currently checked item is not already in the Gallery.
            if (parent) {
                if (parent.type === TypeConstants.GALLERY && parent.scrollToSelection) {
                    if (!parent.getChildren().some(function (child) {
                        return child.get("checked") === true;
                    }, this)) {
                        parent.refresh();
                    }
                } else {
                    grandParent = parent.getParent();
                    if (grandParent && grandParent.type === TypeConstants.GALLERY_POPUP && grandParent.scrollToSelection) {
                        if (this.checked && !grandParent._invokingGallery.getChildren().some(function (child) {
                            return child.get("actionId") === this.get("actionId");
                        }, this)) {
                            if (originator && originator.source === "UI") {
                                grandParent.galleryStateChanged();
                            } else if (grandParent.refreshGallery) {
                                grandParent.refreshGallery();
                            }
                        }
                    }
                }
            }
        },

        _qeSetChecked: function(check) {
            this.set("checked", check, true);
        }
    });
});
